import dayjs from 'dayjs'
import { redFunnelAPI } from '../api/api'
import {
  handleError,
  handleReceive,
  setAccommodationsAreDisabled,
  setFerryAccommodations,
  setFerryAttractions,
} from '../redux/configuration'

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Europe/London')

const bootstrapApp = () => dispatch => {
  const promises = [
    redFunnelAPI
      .getConfiguration()
      .then(res => res.data)
      .catch(err =>
        dispatch(
          handleError(
            err?.response?.data?.['hydra:description'] ||
              err?.message ||
              'Unable to fetch config.',
          ),
        ),
      ),
    redFunnelAPI
      .getActiveNewSessions()
      .catch(err => {
        dispatch(
          handleError(
            err?.response?.data?.['hydra:description'] ||
              err?.message ||
              'Unable to fetch config.',
          ),
        )
      })
      .then(res => +res),
    redFunnelAPI.getFerrySettings().then(res => {
      dispatch(
        setAccommodationsAreDisabled(
          !res?.data?.data?.settings?.accommodationsEnabled,
        ),
      )
      dispatch(
        setFerryAccommodations(res?.data?.data?.ferryAccommodations || []),
      )
      dispatch(setFerryAttractions(res?.data?.data?.ferryAttractions || []))
    }),
  ]

  return Promise.all(promises).then(([configRes, sessionCount]) => {
    let response = null
    if (configRes) {
      response = {
        config: configRes,
        sessionCount: sessionCount || null,
      }
      dispatch(handleReceive(response))
    } else {
      dispatch(handleError('Unable to fetch config.'))
    }
    return response
  })
}

export default bootstrapApp
